// @ts-nocheck
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { errorToast, successToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { isNumberPrice } from "../../utils/validation";
import AddIcon from "@mui/icons-material/Add";
import {
  useAddServiceMutation,
  useLazyAllSettingsQuery,
  useAddTimeMutation,
} from "../../services/settings";
import { useNavigate } from "react-router-dom";
import Loader from "../../helpers/constants/Loader";
import { useGetCmsMutation } from "../../services/cms";
import useTranslation from "../../hooks/Translation";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AddSettings = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const [allSettings] = useLazyAllSettingsQuery();
  const [addTime] = useAddServiceMutation();
  const [addService] = useAddTimeMutation();
  const [value, setValue] = useState(0);
  const [cmsSupportApi] = useGetCmsMutation();
  const [settingData, setSettingData] = useState([]);
  const [cmsData, setCmsData] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      responseTime: cmsData?.time?.response_time || "",
      deliveryTime: cmsData?.time?.avg_delivery_time || "",
      deliveryFees: cmsData?.time?.delivery_fees || "",
      orders_cancellation_time:
        cmsData?.service_fee?.orders_cancellation_time || "",
      orders_exchange_time: cmsData?.service_fee?.orders_exchange_time || "",
    },
    validationSchema: Yup.object({
      responseTime: Yup.string().required("Response time is required"),
      deliveryTime: Yup.string().required("Average delivery time is required"),
      deliveryFees: Yup.string().required("Delivery fees is required"),
      orders_cancellation_time: Yup.string().required(
        "Order Cancellation Time is required"
      ),
      orders_exchange_time: Yup.string().required(
        "Order Exchange Time is required"
      ),
    }),

    onSubmit: async (values) => {
      formik.setSubmitting(true);
      let body = {
        response_time: formik?.values?.responseTime,
        avg_delivery_time: formik?.values?.deliveryTime,
        delivery_fees: formik?.values?.deliveryFees,
      };
      let body2 = {
        orders_cancellation_time: Number(
          formik?.values?.orders_cancellation_time
        ),
        orders_exchange_time: Number(formik?.values?.orders_exchange_time),
      };

      try {
        const response = await addTime(body).unwrap();
        const response2 = await addService(body2).unwrap();
        if (response?.status === 200 && response2?.status === 200) {
          successToast("Settings updated successfully");
        } else {
          successToast(response?.message || "Something went wrong");
        }
      } catch (error) {
        // successToast(error?.data?.message || "");
      }
    },
  });

  const getAllSettings = async () => {
    setLoading(true);
    try {
      const response = await allSettings({}).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setSettingData(response?.data);
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  const fetchContactSupport = async () => {
    try {
      const response = await cmsSupportApi({}).unwrap();
      if (response?.status === 200) {
        setCmsData(response?.data);
      }
    } catch (e: any) {
      errorToast(e?.message || "Failed to fetch CMS data");
    }
  };

  useEffect(() => {
    getAllSettings();
    fetchContactSupport();
  }, []);

  return (
    <div>
      <Loader isLoad={loading} />
      <div className="main_layout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.settings}</h1>
        </div>
        <Card className="cards">
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2}></Grid>
            <Box className="custom_tabs" marginTop={3}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                {/* <Tab label="Mortage" {...a11yProps(1)} /> */}
                <Tab label={t.main.serviceFee} {...a11yProps(0)} />
                <Tab label={t.main.general} {...a11yProps(1)} />
                <Tab label={t.main.timing} {...a11yProps(2)} />
              </Tabs>
              <CustomTabPanel value={value} index={0}>
                <Box className="cards_header">
                  <div />
                  <Box className="cards_header_right">
                    <Button
                      className="btn btn_primary"
                      onClick={() => navigate("/settings/add")}
                    >
                      <AddIcon />
                      {t.main.add}
                    </Button>
                  </Box>
                </Box>
                <TableContainer className="table_container">
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">S.No</TableCell>
                        <TableCell>{t.main.category}</TableCell>
                        <TableCell>{t.main.type}</TableCell>
                        <TableCell>{t.main.platformCommission}</TableCell>
                        <TableCell>{t.main.tax}</TableCell>
                        <TableCell>{t.main.actions}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {settingData?.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={9} align="center">
                            {t.error.noData}
                          </TableCell>
                        </TableRow>
                      ) : (
                        settingData?.map((row: any, i: number) => (
                          <TableRow key={row.id}>
                            <TableCell align="center">{i + 1}</TableCell>

                            <TableCell>
                              {row?.category?.category_name || "-"}
                            </TableCell>
                            <TableCell>
                              {row?.platform_commission_type === 1
                                ? "Flat"
                                : "Percentage"}
                            </TableCell>
                            <TableCell>
                              <Typography variant="h6" fontSize={14}>
                                {row?.platform_commission_type === 1
                                  ? `AED ${row?.platform_commission_flat}`
                                  : `${row?.platform_commission_percentage} %`}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="h6" fontSize={14}>
                                {row?.platform_commission_type === 1
                                  ? `AED ${row?.tax_flat}`
                                  : `${row?.tax_percentage} %`}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Box className="table_actions">
                                <IconButton
                                  onClick={() =>
                                    navigate(`/settings/edit/${row?.id}`)
                                  }
                                >
                                  <ModeEditIcon />
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CustomTabPanel>

              <CustomTabPanel value={value} index={1}>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Typography className="custom_label">
                        {t.main.responseTime}
                      </Typography>
                      <TextField
                        hiddenLabel
                        className="text_field"
                        type="text"
                        name="responseTime"
                        variant="outlined"
                        fullWidth
                        inputProps={{ maxLength: 3 }}
                        placeholder="Enter here"
                        onChange={formik?.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values?.responseTime}
                        error={
                          formik.touched?.responseTime &&
                          Boolean(formik.errors.responseTime)
                        }
                        helperText={
                          formik.touched.responseTime &&
                          formik.errors.responseTime
                        }
                      />
                    </Grid>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Typography className="custom_label">
                        {t.main.avgDeliveryTime}
                      </Typography>
                      <TextField
                        hiddenLabel
                        className="text_field"
                        type="text"
                        name="deliveryTime"
                        variant="outlined"
                        fullWidth
                        inputProps={{ maxLength: 3 }}
                        placeholder="Enter here"
                        onChange={formik?.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values?.deliveryTime}
                        error={
                          formik.touched?.deliveryTime &&
                          Boolean(formik.errors.deliveryTime)
                        }
                        helperText={
                          formik.touched.deliveryTime &&
                          formik.errors.deliveryTime
                        }
                      />
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Typography className="custom_label">
                        {t.main.deliveryFees}
                      </Typography>
                      <TextField
                        hiddenLabel
                        className="text_field"
                        type="text"
                        name="deliveryFees"
                        variant="outlined"
                        fullWidth
                        inputProps={{ maxLength: 5 }}
                        placeholder="Enter here"
                        onChange={(val) => {
                          const value = val.target.value;
                          if (value === " " || value === ".") return;

                          // Regex to allow only numbers with up to two decimal places
                          if (/^\d*\.?\d{0,2}$/.test(value)) {
                            formik?.handleChange(val);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values?.deliveryFees}
                        error={
                          formik.touched?.deliveryFees &&
                          Boolean(formik.errors.deliveryFees)
                        }
                        helperText={
                          formik.touched.deliveryFees &&
                          formik.errors.deliveryFees
                        }
                      />
                    </Grid>
                  </Grid>

                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                    >
                      {t.main.save}
                    </Button>
                  </div>
                </form>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Typography className="custom_label">
                        {t.main.orderCancellationTime}
                      </Typography>
                      <TextField
                        hiddenLabel
                        className="text_field"
                        type="text"
                        name="orders_cancellation_time"
                        variant="outlined"
                        fullWidth
                        inputProps={{ maxLength: 3 }}
                        placeholder="Enter here"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          formik.setFieldValue(e.target.name, value);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values?.orders_cancellation_time}
                        error={
                          formik.touched?.orders_cancellation_time &&
                          Boolean(formik.errors.orders_cancellation_time)
                        }
                        helperText={
                          formik.touched.orders_cancellation_time &&
                          formik.errors.orders_cancellation_time
                        }
                      />
                    </Grid>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Typography className="custom_label">
                        {t.main.orderExchangeTime}
                      </Typography>
                      <TextField
                        hiddenLabel
                        className="text_field"
                        type="text"
                        name="orders_exchange_time"
                        variant="outlined"
                        fullWidth
                        inputProps={{ maxLength: 3 }}
                        placeholder="Enter here"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          formik.setFieldValue(e.target.name, value);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values?.orders_exchange_time}
                        error={
                          formik.touched?.orders_exchange_time &&
                          Boolean(formik.errors.orders_exchange_time)
                        }
                        helperText={
                          formik.touched.orders_exchange_time &&
                          formik.errors.orders_exchange_time
                        }
                      />
                    </Grid>
                  </Grid>

                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                    >
                      {t.main.save}
                    </Button>
                  </div>
                </form>
              </CustomTabPanel>
            </Box>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AddSettings;
